import React from "react";

const BodyWrapper = ({ children }) => {
  return (
    <div className="w-full flex flex-col pb-8 min-h-0 flex-1 animate-fadeIn">
      {children}
    </div>
  );
};

export default BodyWrapper;
